<template> 

  <div class="container pt-4 mb-5">
     
    <div>
      
      <b-row align-v="center">

        <b-col lg="12">
 
          <div class="mt-4">

            <div class="mt-3">

              <label>Wpisz pomysł lub tytuł filmiku:</label>

              <b-input-group>

                <b-form-input v-model="pomysl" size="lg" ref="pomysl" placeholder="np. dieta, nauka angielskiego, marketing, instagram"></b-form-input>
                
              </b-input-group>
 
            </div>

            <b-form-group class="mt-3" label="Wybierz strukturę pomysłu na początek filmiku:" v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                  id="radio-group-1"
                  v-model="schemat"
                  :options="schematy"
                  :aria-describedby="ariaDescribedby"
                  name="schemat"
                  stacked
              ></b-form-radio-group>
            </b-form-group>

            <br/>

          </div>

        </b-col>

      </b-row>
  
      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">
        
        </b-col>

        <b-col lg="6">

        <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
          Generuj początek
        </b-button> 

        </b-col>

      </b-row>



      <div class="mt-2" >
  
        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje początek <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Wygenerowany początek</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">
            
            <div v-html="result" class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;"></div>

            <div class="text-primary pointer small mt-1 float-right" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>
   
        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>   
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>
 
    </div>

  </div>

</template>

<script>

  export default {
    name: 'App12XSellingMachineAI',
    components: {
    },
    data() {
      return {
        isFinish: false,
        result: "",
        selectedText: '',
        query: "",
        pomysl: "",
        schemat: "Wymyśl mi 10 zatrzymujących uwagę początków na filmiki na temat [POMYSL]. Zacznij od przykładowych zwrotów takich jak: Szok! To niesamowite... Jestem w szoku, ale to działa... poznaj te szokujące...",
        schematy: [
          {
            text: "Szokujący początek",
            value: "Wymyśl mi 10 zatrzymujących uwagę początków na filmiki na temat [POMYSL]. Zacznij od przykładowych zwrotów takich jak: Szok! To niesamowite... Jestem w szoku, ale to działa... poznaj te szokujące..."
          },
          {
            text: "Dlaczego nikt o tym nie mówi",
            value: "Wymyśl mi 10 zatrzymujących uwagę początków na filmiki na temat [POMYSL]. Zacznij od przykładowych zwrotów takich jak: Dlaczego nikt o tym nie mówi... dlaczego eksperci o tym nie mówią... dlaczego poiero teraz się o tym dowiedziałem..."
          },
          {
            text: "To się dzieje naprawdę!",
            value: "Wymyśl mi 10 zatrzymujących uwagę początków na filmiki na temat [POMYSL]. Zacznij od przykładowych zwrotów takich jak: To się dzieje naprawdę... Nie uwierzysz! To się dzieje naprawdę"
          },
          {
            text: "To co za chwilę zobaczysz",
            value: "Wymyśl mi 10 zatrzymujących uwagę początków na filmiki na temat [POMYSL]. Zacznij od przykładowych zwrotów takich jak: To co za chwilę zobaczysz jest niesamowite... Zobacz to, ale oglądasz to na swoją odpowiedzialność"
          },
          {
            text: "Nowość",
            value: "Wymyśl mi 10 zatrzymujących uwagę początków na filmiki na temat [POMYSL]. Zacznij od przykładowych zwrotów takich jak: UWAGA! Nowość... Już jest... To jest tak nowe, że nikt o tym nie mówi..."
          },
          {
            text: "Tajny Trick",
            value: "Wymyśl mi 10 zatrzymujących uwagę początków na filmiki na temat [POMYSL]. Zacznij od przykładowych zwrotów takich jak: Tajny trick... Tajna sztuczka... Sekret..."
          },
          {
            text: "A co jeżeli powiem Ci",
            value: "Wymyśl mi 10 zatrzymujących uwagę początków na filmiki na temat [POMYSL]. Zacznij od przykładowych zwrotów takich jak: A jeżeli powiem Ci, że wszystko co wiedziałeś na temat... A co jeżeli powiem Ci, że większość osób myli się na temat..."
          },
          {
            text: "Cała prawda o",
            value: "Wymyśl mi 10 zatrzymujących uwagę początków na filmiki na temat [POMYSL]. Zacznij od przykładowych zwrotów takich jak: Cała prawda o... Poznaj tą niewygodną prawdę nt... To niewygodna prawda o..."
          },
          {
            text: "Tajna strona",
            value: "Wymyśl mi 10 zatrzymujących uwagę początków na filmiki na temat [POMYSL]. Zacznij od przykładowych zwrotów takich jak: Tajna strona www... Tajna strona o której nie miałeś pojęcia..."
          },
          {
            text: "Nie popełniaj tego błędu",
            value: "Wymyśl mi 10 zatrzymujących uwagę początków na filmiki na temat [POMYSL]. Zacznij od przykładowych zwrotów takich jak: Nie popełniaj tego błędu... Nie rób tego błędu podczas... Jeżeli chcesz mieć efekty w..."
          },
          {
            text: "Jaki jest najlepszy sposób na",
            value: "Wymyśl mi 10 zatrzymujących uwagę początków na filmiki na temat [POMYSL]. Zacznij od przykładowych zwrotów takich jak: Poznaj ten najlepszy sposób na... Oto najlepszy sposób na..."
          }
        ],
        finishContent: '',
        selectedSchema: null
      }
    },
    methods: {
  
      generateFinish: function() {

        if(!this.pomysl) return false;

        this.$refs.generatePost.disabled = true

        this.isFinish = true

        this.finishContent = ""
        this.result = ""


        var query = this.schemat

        query = query.replaceAll('[POMYSL]', this.$refs.pomysl.value)


        var doneText = "";

        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query }, { withCredentials: true, timeout: 3000000 }).then((response) => {
  
          let data = response.data
 
          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          doneText = data.result;

          this.finishContent = doneText;

          this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/>');

          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowany początek"

        }).catch(function() {

          this.$refs.generatePost.disabled = false

         })
 
        
 
      },
 
      copyResults: function() {
 
        this.$refs.finishContent.style.display = "block";
        
        this.$refs.finishContent.focus();

        document.execCommand('copy');
         
        this.$refs.finishContent.style.display = "none"

        window.scrollTo(0, 0)

        this.$bvToast.toast('Treść została skopiowana do schowka', {
          title: 'Skopiowano',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })

      } 

    },
    computed: {
  
    },
    created() {

      this.$watch('finishContent', (value) => {

        var lines = value.split(/\r|\r\n|\n/);

        this.finishLinesCount = lines.length;

      })
 
    }

  }
</script>

<style>

  .pointer { cursor: pointer; }
  .bold { font-weight: 600 !important; }
  code { color: #4e82f7 !important; }
</style>